import UserPost from "../../../shared/user-post/user-post";
import StarsRating from "../../../shared/stars-rating/stars-rating";
import {isHtmlEmpty, trimHtml} from "../../../../utils/utils";
import React from "react";

import './full-review-item.scss';
import TmdbImage from "../../../shared/tmdb-image/tmdb-image";
import useSquadflixNavigate from "../../squadflixHome/useSquadflixNavigate";
import {ItemReviewDTO} from "../../../../apis/chatbot/api-types";

type Props = {
    review: ItemReviewDTO;
}

const FullReviewItem = ({review}: Props) => {

    const useSquadflixNav = useSquadflixNavigate({});

    const handleNavigateToItem = () => {
        if (review.is_movie) {
            useSquadflixNav.navigateToMovie(review.tmdb_item);
        } else {
            useSquadflixNav.navigateToSerie(review.tmdb_item);
        }
    }

    return <UserPost user={review.user} postDate={review.review_date} includeTime={false}>
        <div className="full-review-item">
            <div className="full-review-item__review-info">
                <TmdbImage src={review.tmdb_item.poster_path} className="full-review-item__poster"/>
                <div>
                    <button onClick={handleNavigateToItem} className="full-review-item__title">
                        {review.tmdb_item.title ?? review.tmdb_item.name}
                    </button>
                    {review.episode != null && <div>
                        <i className="tmdb-item-reviews__date text-muted" style={{
                            fontSize: '0.9rem'
                        }}>
                            Temporada {review.season}, Episodio {review.episode}
                        </i>
                    </div>}
                    <div className="d-flex gap-4 flex-row mt-1">
                        <StarsRating rating={review.vote} size={"medium"}/>
                        {review.like && <i className="fa-solid fa-heart text-danger" style={{fontSize: 20}}></i>}
                    </div>
                </div>
            </div>
            {!isHtmlEmpty(review.review) &&
                <blockquote className="full-review-item__wrapper"
                            dangerouslySetInnerHTML={{__html: trimHtml(review.review!)}}>
                </blockquote>}
        </div>
    </UserPost>
}

export default FullReviewItem;
